// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayVideo_container__32ph0"};